module.exports = __webpack_public_path__ + "img/cattunnel18.14224723.jpg";